import { NavigationExtras } from '@angular/router';
import { createAction, props } from '@ngrx/store';

export const ROUTER_NEXT = createAction(
    'ROUTERNEXT', props<{ payload: { path: any[]; query?: object; extras?: NavigationExtras } }>()
);